<div class="emd-container">
    <div class="emd-container__header">
        <h2 class="emd-text _size_section _color_default">Justificativa</h2>
    </div>
    <div class="emd-container__content">
        <!-- Botão de fechar a direita do box -->
        <div class="emd-container__aside">
            <button class="emd-btn _color_clear" (click)="handleClose()">
                <i class="fa fa-times"></i>
            </button>
        </div>
        <textarea
            class="form-control emd-input"
            name="justification"
            rows="5"
            style="box-shadow: none"
            [(ngModel)]="rejectJustification"
        ></textarea>
    </div>
    <div class="emd-container__footer eu-display_flex eu-justify_end">
        <button
            class="emd-btn _color_primary _size_small _block reject-button"
            (click)="confirmReject()"
        >
            <span>Confirmar</span>
        </button>
        <button
            class="emd-btn _color_danger _size_small _block reject-button"
            (click)="handleClose()"
        >
            <span>Cancelar</span>
        </button>
    </div>
</div>
